export default {
  // createApplication
  START_CREATE_APP: 'START_CREATE_APP',
  CREATE_APP_SUCCESS: 'CREATE_APP_SUCCESS',
  CREATE_APP_FAILED: 'CREATE_APP_FAILED',
  // getApplicationList
  START_GET_APP_LIST: 'START_GET_APP_LIST',
  GET_APP_LIST_SUCCESS: 'GET_APP_LIST_SUCCESS',
  GET_APP_LIST_FAILED: 'GET_APP_LIST_FAILED',
  // getApplicationById
  START_GET_APP_BY_ID: 'START_GET_APP_BY_ID',
  GET_APP_BY_ID_SUCCESS: 'GET_APP_BY_ID_SUCCESS',
  GET_APP_BY_ID_FAILED: 'GET_APP_BY_ID_FAILED',
  // updateApplication
  START_UPDATE_APP: 'START_UPDATE_APP',
  UPDATE_APP_SUCCESS: 'UPDATE_APP_SUCCESS',
  UPDATE_APP_FAILED: 'UPDATE_APP_FAILED',

  // deleteApplication
  START_DELETE_APP: 'START_DELETE_APP',
  DELETE_APP_SUCCESS: 'DELETE_APP_SUCCESS',
  DELETE_APP_FAILED: 'DELETE_APP_FAILED'
};
